import React from 'react';
import { FormControl, FormGroup, Button, Row, Col } from 'react-bootstrap';
import Api from '../../api/api';
import Validator from '../Validation/Validator';
import ValidatedField from '../Validation/ValidatedField';

class ChangePassword extends React.Component {
  state = {
    password: '',
    password_confirmation: '',
    errors: [],
  };

  validator = new Validator({
    password: [Validator.min(8)],
    password_confirmation: [Validator.same('password')],
  });

  handleInputChange = (field: string, event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      [field]: event.target.value,
    });
  };

  handleSubmit = () => {
    this.setState({ ...this.state, errors: [] }, () => {
      const errors = this.validator.validate(this.state);

      if (errors.length) {
        this.setState({ errors });
      } else {
        Api.users
          .resetPassword({
            user: {
              reset_password_token: this.props.reset_password_token,
              password: this.state.password,
              password_confirmation: this.state.password_confirmation,
            },
          })
          .then(() => {
            this.props.setMessage(
              'Your password has been successfully reset. You may now log in using your new password.',
            );
            this.props.clearPasswordToken();
            this.props.clearRouterHistorySearch();
          })
          .catch(() => {
            this.props.setMessage('An error has occured. Try once more.');
          });

        this.props.handleModalClose();
      }
    });
  };

  render() {
    return (
      <div className="main-fullheight">
        <div className="fullheight">
          <Row className="show-grid">
            <Col md={12} className="show-grid-in show-grid-pass">
              <h2 className="heading hd-left forgot-pass">Enter new password</h2>
              <FormGroup>
                <Col md={12} className="first-line">
                  <ValidatedField field="password" errors={this.state.errors}>
                    <FormControl
                      type="password"
                      placeholder="Enter your password"
                      onChange={e => this.handleInputChange('password', e)}
                      value={this.state.password}
                    />
                  </ValidatedField>
                </Col>
                <Col md={12}>
                  <ValidatedField field="password_confirmation" errors={this.state.errors}>
                    <FormControl
                      type="password"
                      placeholder="Confirm your password"
                      onChange={e => this.handleInputChange('password_confirmation', e)}
                      value={this.state.password_confirmation}
                    />
                  </ValidatedField>
                </Col>
              </FormGroup>
              <Col md={6} />
              <Col md={6}>
                <Button onClick={this.handleSubmit} bsStyle="primary">
                  Ok
                </Button>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/Login/ChangePassword.js